import { Component, Input, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { LanguageService } from "src/app/service/language-service/language.service";

/**
 * Estado vacío reutilizable para las secciones de anuncios/novedades. Muestra la
 * ilustración por defecto (`search-image`) y el mensaje "aquí aparecerán los
 * anuncios cuando sean asignados" en el idioma activo.
 *
 * Se usa tanto en la página de Anuncios de la plataforma de capacitación como en
 * la sección de novedades del home de Desempeño. La vista decide cuándo mostrarlo
 * (cuando no hay anuncios y ya terminó la carga).
 */
@Component({
	selector: "app-empty-announcements",
	templateUrl: "./empty-announcements.component.html",
	styleUrls: ["./empty-announcements.component.scss"],
})
export class EmptyAnnouncementsComponent implements OnDestroy {
	/** Ocupa el alto de la pantalla (página de Anuncios). Off en secciones embebidas. */
	@Input() fullHeight = false;

	language = "es";
	private langSub?: Subscription;

	constructor(private languageService: LanguageService) {
		this.langSub = this.languageService.getCurrentLang().subscribe((lang) => (this.language = lang));
	}

	ngOnDestroy() {
		this.langSub?.unsubscribe();
	}
}
